import React from 'react';
import { useTranslation } from 'react-i18next';

const MonthlyCareContent = () => {
  const { t , i18n} = useTranslation()

  return (
    <div className="content px-4">
    <p>Managed & Supported</p>
    <h3 className='uppercase'>{t("Monthly care plans")}</h3>
    <p className="mt-2">
    {t("A successful website isn’t built once, it’s maintained and improved every month. Our monthly care plans are designed to keep your site running at peak performance. We handle everything from software updates and security monitoring to backups and performance optimization. This way, you can focus on growing your business while we make sure your website remains secure, fast, and always ahead of the curve.")}

    </p>
  </div>
  );
}

export default MonthlyCareContent;
